import { HeroSection } from "../components/landing/HeroSection";
import { RebrandHeroSection } from "../components/landing/RebrandHeroSection";
import { StorytellingSection } from "../components/landing/StorytellingSection";
import { IntroducingLizSection } from "../components/landing/IntroducingLizSection";
import { GlobalZoomSection } from "../components/landing/GlobalZoomSection";
import { CurriculumSection } from "../components/landing/CurriculumSection";
import { CouplingAppSection } from "../components/landing/CouplingAppSection";
import { EventVideoSection } from "../components/landing/EventVideoSection";
import { DatingAgencySection } from "../components/landing/DatingAgencySection";
import { SocialProofSection } from "../components/landing/SocialProofSection";
import { TestimonialsSection } from "../components/landing/TestimonialsSection";
import { SNSSection } from "../components/landing/SNSSection";
import { SevenStepsSection } from "../components/landing/SevenStepsSection";
import { FinalCTASection } from "../components/landing/CommunityValueSections";
import { FooterSection } from "../components/landing/FooterSection";

export const LandingPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <main className="flex flex-col">
        <RebrandHeroSection />
        <HeroSection />
        <StorytellingSection />
        <IntroducingLizSection />
        <SevenStepsSection />
        <TestimonialsSection />
        <GlobalZoomSection />
        <CouplingAppSection />
        <CurriculumSection />
        <EventVideoSection />
        <DatingAgencySection />
        <SocialProofSection />
        <SNSSection />
        <FinalCTASection />
      </main>
      <FooterSection />
    </div>
  );
};

export default LandingPage;
